module.exports = __webpack_public_path__ + "static/expert_monetize-faa23db7ce25e73aef40c3574f05cca7.svg";